import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotArticles from './components/HotArticles';
import CategoryNav from './components/CategoryNav';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黑料曝光',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    description: '黑料曝光专题页，汇聚最新、最全的真实内幕信息。娱乐圈、商业圈、网红博主黑料曝光内容全收录。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: '/category/{search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料曝光',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    description: '真实内幕全收录，助你看清真相、辨别是非。',
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '黑料曝光 - 真实内幕全收录',
    description: '黑料曝光专题页，汇聚最新、最全的真实内幕信息。无论是娱乐圈、商业圈还是网红博主，这里第一时间呈现经过核实的黑料曝光内容。',
  };

  return (
    <>
      <SEOHead
        schema={[websiteSchema, orgSchema, webpageSchema]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotArticles />
        <CategoryNav />
        <LatestArticles />
      </main>
      <Footer />
    </>
  );
}